var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C10.86 0 14 3.14005 14 7C14 10.86 10.86 14 7 14C3.14005 14 0 10.86 0 7C0 3.14005 3.14005 0 7 0ZM7 10.2375C6.67796 10.2375 6.4167 10.4988 6.4167 10.8208C6.4167 11.1428 6.67796 11.4041 7 11.4041C7.32204 11.4041 7.5833 11.1428 7.5833 10.8208C7.5833 10.4988 7.32204 10.2375 7 10.2375ZM7 3.2083C5.5527 3.2083 4.375 4.38611 4.375 5.8333C4.375 6.15533 4.63573 6.4167 4.9583 6.4167C5.28087 6.4167 5.5417 6.15533 5.5417 5.8333C5.5417 5.02954 6.1956 4.375 7 4.375C7.8044 4.375 8.4583 5.02954 8.4583 5.8333C8.4583 6.18973 8.02902 6.91605 7.43462 7.18959C6.81682 7.47488 6.4167 8.09898 6.4167 8.7798V9.0417C6.4167 9.36363 6.67743 9.625 7 9.625C7.32257 9.625 7.5833 9.36363 7.5833 9.0417V8.7798C7.5833 8.55283 7.71692 8.34454 7.92339 8.24948C8.9413 7.77994 9.625 6.62146 9.625 5.8333C9.625 4.38611 8.4473 3.2083 7 3.2083Z",
    fill: "#4d4d4d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpFilled);
export default __webpack_public_path__ + "static/media/help_filled.4a81277fa39949e9b906efbfe58796a8.svg";
export { ForwardRef as ReactComponent };